import { Component, AppNavbar,AppBody } from "../../utils/modules.jsx";
class App extends Component {
  render() {
    return (
      <>
        <AppNavbar />
        <AppBody />
      </>
    );
  }
}

export default App;
